// tis fake user is used when generating AI interactions not linked to any app user
export const AI_INTERACTION_FAKE_USER_ID = '6810e1a9cd85eb62fa1450fd';
